export enum MESSAGES {
  TRANSACTION_SUPPORT = "You will not be able to do any transaction. Please contact the support at support@ktoexchange.com",
  ACCOUNT_DISABLED = "Your account is disabled",
  ACCOUNT_BLOCKED = "Your account is blocked",
  REQUEST_TIME_OUT = "Request timeout! Please try again.",
  LOGOUT = "Logged out successfully",
  NEW_PHONE_ERROR = "New phone number should not be same as current phone number.",
  NEW_EMAIL_ERROR = "New email address should not be same as current email address.",
  LOGIN_AGAIN = "Please login again to continue.",
  TRANSACTION_HOLD_MESSAGE = "You have not yet selected a wallet to deposit funds. Please select the wallet from your whitelisted wallets.",
  TRANSACTION_HOLD_TITLE = "Transaction On Hold",
  SUCCESS_MESSAGE = "Your wallet is successfully connected",
  TRANSACTION_SUCCESS_MESSAGE = "Your transaction for the deposit of 10 ETH is successfully completed.",
  SUCCESS_TITLE = "Congratulations",
  NO_OPEN_ORDERS = "No orders in the list yet, create an order.",
  NO_ORDER_HISTORY = "Order history records will be displayed once the order processed.",
  CANCEL_ORDER_SUCCESS = `NOTE : Your cancellation request will be accepted, please note however if the order is already under execution, it won't be cancelled.`,
  NO_TRADE_HISTORY = "Trade history will be displayed once the order gets executed.",
  CHECK_ORDER_STATUS = "Check for your order status in open orders.",
  ORDER_CANCELLATION_ONGOING = "NOTE : Your cancellation request is in progress. Please note if your order is already under execution, it will not be cancelled.",
}
